import {TextField, Autocomplete} from "@mui/material";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {ThemeProvider, createTheme} from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: {
                    alignItems: 'center !important',
                },
            },
        },
    },
});


export default function CondObjAcOne(props: any) {
    let {authTokens, serverIP} = useContext(AuthContext)

    const {change, name, fieldType, mapData, val, rule, condObject, setCondObject} = props
    // console.log(val)
    // const viewURL: any = mapData.mapType === 'template' ? `http://${serverIP}/tmplgetsrcdata/` : `http://${serverIP}/getsrcdata/`

    const queryData: any = {...mapData};
    queryData['fieldType'] = fieldType
    queryData['thisRule'] = rule
    queryData['condObj'] = condObject

    const [valuesArr, setValuesArr] = useState<any[]>(val ? [val] : [])

    return (
        <ThemeProvider theme={theme}>

            <Autocomplete
                key={1}
                value={val}
                onChange={(event, newValue) => {
                    // console.log(newValue)
                    if (newValue) {
                        rule.fieldID = newValue.id
                        rule.fieldName = newValue.label
                    } else {
                        rule.fieldID = ''
                        rule.fieldName = ''
                    }
                    setCondObject(JSON.parse(JSON.stringify(condObject)))
                }}

                isOptionEqualToValue={(option, value) => option.value === value.value}

                onInputChange={(event, newValue) => {

                    if (newValue !== val) {

                        if ((isNaN(parseInt(newValue)) && newValue.length >= 2) || (!isNaN(parseInt(newValue)) && newValue.length >= 1)) {

                            queryData['qString'] = newValue

                            fetch(`${serverIP}/getsrcdata/`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + String(authTokens.access)
                                },
                                body: JSON.stringify(queryData),
                            }).then(res => res.json())
                                .then((data) => {
                                    setValuesArr(data)
                                })
                        } else {
                            setValuesArr([])
                        }
                    }
                }
                }

                disablePortal
                autoHighlight
                handleHomeEndKeys
                forcePopupIcon={false}
                size="small"    // IMPORTANT! It is bind to the CSS class "MuiInputBase-sizeSmall"
                id="combo-box-demo"
                options={valuesArr}
                sx={{width: "auto"}}
                ListboxProps={
                    {
                        style: {
                            fontSize: '0.78rem',
                            fontFamily: "'Inter', sans-serif",
                            color: 'black'
                        }
                    }}

                renderInput={(params) =>
                    <TextField
                        {...params}
                        label=""
                        style={{backgroundColor: 'white'}}
                        // InputProps={{
                        //     style: {height: 30}
                        // }}
                    />}

            />
        </ThemeProvider>
    );
}
